import { MemberDocument, MemberDocumentPresignedUrlPostSchema } from "../types/Document";
import { request } from "./request";

export async function listDocumentsForPlan(enrollmentPlanId: number, resultsPerPage?: number): Promise<{results: {document: MemberDocument}[]}> {
  return await request<{results: {document: MemberDocument}[]}>({
    url: "/document/list",
    method: "POST",
    data: {
      enrollment_plan_id: enrollmentPlanId,
      results_per_page: resultsPerPage,
    },
  });
}

export async function getUrlForDownload(documentId: number, target: "download" | "view"): Promise<MemberDocumentPresignedUrlPostSchema> {
  return await request({
    url: "/document/url_for_download",
    method: "POST",
    data: {
      id: documentId,
      user_target: target,
    },
  });
}
